import React from 'react'
import moment from 'moment'
import { ApolloConsumer } from 'react-apollo'
import { REFRESH_TOKEN } from 'operations/User'
import jwtDecode from 'jwt-decode'

class Refresh extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            refresh: false
        }
        this.timer = this.timer.bind(this)
    }

    componentDidMount() {
        // Run this interval every 1 minute
        setInterval(this.timer, 60000)
    }

    timer() {
        if (localStorage.hasOwnProperty('tokenExpiry')) {
            const tokenExpires = localStorage.getItem('tokenExpiry')
            const time = moment(moment().utc().valueOf()).unix()
            // If token expires in less than 2 minutes
            if (tokenExpires - time < 120000) {
                this.setState({
                    refresh: true
                })
            }
        }
    }

    render() {

        if (!this.state.refresh) return null

        return(
            <ApolloConsumer>
                { client => {
                    if (localStorage.hasOwnProperty('refreshToken')) {
                        const refreshToken = localStorage.getItem('refreshToken')
                        client.mutate({
                            mutation: REFRESH_TOKEN,
                            variables: {
                                data: {
                                    token: refreshToken
                                }
                            }
                        })
                        .then(({data}) => {
                            localStorage.setItem('accessToken', data.refreshToken.accessToken)
                            const decoded = jwtDecode(data.refreshToken.accessToken)
                            localStorage.setItem('tokenExpiry', decoded.exp)
                        })
                        .catch(err => {
                            localStorage.removeItem('accessToken')
                            localStorage.removeItem('refreshToken')
                            localStorage.removeItem('tokenExpiry')
                            client.resetStore()
                        })
                    }
                    return null
                }}
            </ApolloConsumer>
        )
    }

}

export default Refresh


// WEBPACK FOOTER //
// ./src/Refresh.js